import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "photoshopaction"
    }}>{`photoshopAction`}</h1>
    <p>{`The module that facilitates Actions being performed in the
UXP-Photoshop world. You may perform your own `}<inlineCode parentName="p">{`batchPlay`}</inlineCode>{` commands,
or attach listeners using this module.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var PhotoshopAction = require('photoshop').action;
`}</code></pre>
    <h2 {...{
      "id": "functions"
    }}>{`Functions`}</h2>
    <h3 {...{
      "id": "addnotificationlistener"
    }}>{`addNotificationListener`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Attach a listener to a Photoshop event. A callback in the form
of `}<inlineCode parentName="p">{`(eventName: string, descriptor: Descriptor) => void`}</inlineCode>{` will be performed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`await PhotoshopAction.addNotificationListener(['open'], onOpenNewDocument)
`}</code></pre>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`events`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`notifier`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`NotificationListener`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "batchplay"
    }}>{`batchPlay`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
      }}><em parentName="a">{`ActionDescriptor`}</em></a>{`[]`}{`>`}</p>
    <p>{`Performs a batchPlay call with the provided commands. Equivalent
to an `}<inlineCode parentName="p">{`executeAction`}</inlineCode>{` in ExtendScript.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var target = { _ref: 'layer', _enum: 'ordinal', _value: 'targetEnum'}
var commands = [{ _obj: 'hide', _target: target }]
await PhotoshopAction.batchPlay(commands)
`}</code></pre>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`commands`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
            }}><em parentName="a">{`ActionDescriptor`}</em></a>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/batchplaycommandoptions/"
            }}><em parentName="a">{`BatchPlayCommandOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "batchplaysync"
    }}>{`batchPlaySync`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
      }}><em parentName="a">{`ActionDescriptor`}</em></a>{`[]`}</p>
    <p>{`Performs a batchPlay call with the provided commands. Equivalent
to an `}<inlineCode parentName="p">{`executeAction`}</inlineCode>{` in ExtendScript.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var target = { _ref: 'layer', _enum: 'ordinal', _value: 'targetEnum'}
var commands = [{ _obj: 'hide', _target: target }]
await PhotoshopAction.batchPlay(commands)
`}</code></pre>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`commands`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
            }}><em parentName="a">{`ActionDescriptor`}</em></a>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/batchplaycommandoptions/"
            }}><em parentName="a">{`BatchPlayCommandOptions`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "removenotificationlistener"
    }}>{`removeNotificationListener`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Detaches a listener from a Photoshop event.`}</p>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`events`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`notifier`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`NotificationListener`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "validatereference"
    }}>{`validateReference`}</h3>
    <p><em parentName="p">{`boolean`}</em></p>
    <p>{`Synchronously validates the given action reference, returning true if it still
exists. For example, calling this with a closed document would return false.`}</p>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ActionReference `}{`|`}{` ActionReference[]`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      